var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashHProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14286 1H3.85714C2.27919 1 1 2.27919 1 3.85714V9.57143",
    stroke: "#05073C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39285 7.07164C3.39285 6.22812 3.39322 5.6164 3.44663 5.14267C3.49947 4.67398 3.60156 4.37139 3.78401 4.13363C3.88471 4.00239 4.00218 3.88492 4.13341 3.78422C4.37118 3.60177 4.67376 3.49968 5.14246 3.44684C5.61619 3.39344 6.2279 3.39307 7.07142 3.39307C7.91494 3.39307 8.52666 3.39344 9.00039 3.44684C9.46908 3.49968 9.77167 3.60177 10.0094 3.78422C10.1407 3.88492 10.2581 4.00239 10.3588 4.13363C10.5413 4.37139 10.6434 4.67398 10.6962 5.14267C10.7496 5.6164 10.75 6.22812 10.75 7.07164V9.92878C10.75 10.7723 10.7496 11.384 10.6962 11.8577C10.6434 12.3264 10.5413 12.629 10.3588 12.8668C10.2581 12.998 10.1407 13.1155 10.0094 13.2162C9.77167 13.3986 9.46908 13.5007 9.00039 13.5536C8.52666 13.607 7.91494 13.6074 7.07142 13.6074C6.2279 13.6074 5.61619 13.607 5.14246 13.5536C4.67376 13.5007 4.37118 13.3986 4.13341 13.2162C4.00218 13.1155 3.88471 12.998 3.78401 12.8668C3.60156 12.629 3.49947 12.3264 3.44663 11.8577C3.39322 11.384 3.39285 10.7723 3.39285 9.92878V7.07164Z",
    stroke: "#05073C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashHProductIcon);
export default __webpack_public_path__ + "static/media/dash-h-product-icon.8634ad09f839b6839f1c5b1e3fa12037.svg";
export { ForwardRef as ReactComponent };